var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaSmallIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3682)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2305 28.7245L22.5147 26.9638C21.8472 26.7611 21.2629 26.3486 20.8483 25.7875C20.4338 25.2265 20.2111 24.5468 20.2133 23.8493V20.2183H9.77941V23.8493C9.78205 24.5472 9.55956 25.2273 9.14499 25.7887C8.73041 26.3501 8.14585 26.7629 7.47808 26.9658L1.76225 28.7265C1.61439 28.7735 1.48813 28.8716 1.40614 29.0033C1.32415 29.135 1.29179 29.2916 1.31488 29.445C1.33798 29.5985 1.41501 29.7386 1.53214 29.8403C1.64927 29.9421 1.79884 29.9987 1.95397 30.0001H28.0388C28.195 30.0002 28.3461 29.9442 28.4645 29.8423C28.5829 29.7404 28.6608 29.5994 28.6841 29.4449C28.7073 29.2904 28.6743 29.1327 28.591 29.0005C28.5078 28.8683 28.3799 28.7704 28.2305 28.7245Z",
    fill: "url(#paint0_linear_743_3682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3852 4.77273C22.5497 3.29252 21.328 2.06695 19.8505 1.22682C18.3729 0.386681 16.6949 -0.0364907 14.9957 0.00246644C12.4014 0.00246644 9.91334 1.03305 8.07889 2.86749C6.24445 4.70193 5.21387 7.18998 5.21387 9.78427V11.0885C5.21387 17.6097 9.77871 23.4788 14.9957 23.4788C20.0529 23.4788 24.484 17.9599 24.7514 11.0885H24.7775V9.78427C24.7772 8.0183 24.2959 6.28577 23.3852 4.77273Z",
    fill: "url(#paint1_linear_743_3682)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -8.74219,
    y: -5.47607,
    width: 47.4763,
    height: 35.0861
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_743_3682_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3682)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7341 15.6536V8.48029C26.7341 7.96143 26.528 7.46382 26.1611 7.09693C25.7943 6.73004 25.2966 6.52393 24.7778 6.52393H5.21417C4.69531 6.52393 4.19771 6.73004 3.83082 7.09693C3.46393 7.46382 3.25781 7.96143 3.25781 8.48029V15.6536C3.25781 16.1725 3.46393 16.6701 3.83082 17.037C4.19771 17.4039 4.69531 17.61 5.21417 17.61H11.3741C11.4847 17.61 11.5935 17.5818 11.6902 17.5282C11.787 17.4746 11.8685 17.3973 11.9271 17.3035L13.1172 15.3986C13.3167 15.0804 13.5937 14.818 13.9223 14.6361C14.2509 14.4542 14.6204 14.3588 14.996 14.3588C15.3716 14.3588 15.741 14.4542 16.0696 14.6361C16.3983 14.818 16.6753 15.0804 16.8747 15.3986L18.0649 17.3035C18.1235 17.3973 18.205 17.4746 18.3017 17.5282C18.3985 17.5818 18.5073 17.61 18.6179 17.61H24.7778C25.2966 17.61 25.7943 17.4039 26.1611 17.037C26.528 16.6701 26.7341 16.1725 26.7341 15.6536Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7341 15.6536V8.48029C26.7341 7.96143 26.528 7.46382 26.1611 7.09693C25.7943 6.73004 25.2966 6.52393 24.7778 6.52393H5.21417C4.69531 6.52393 4.19771 6.73004 3.83082 7.09693C3.46393 7.46382 3.25781 7.96143 3.25781 8.48029V15.6536C3.25781 16.1725 3.46393 16.6701 3.83082 17.037C4.19771 17.4039 4.69531 17.61 5.21417 17.61H11.3741C11.4847 17.61 11.5935 17.5818 11.6902 17.5282C11.787 17.4746 11.8685 17.3973 11.9271 17.3035L13.1172 15.3986C13.3167 15.0804 13.5937 14.818 13.9223 14.6361C14.2509 14.4542 14.6204 14.3588 14.996 14.3588C15.3716 14.3588 15.741 14.4542 16.0696 14.6361C16.3983 14.818 16.6753 15.0804 16.8747 15.3986L18.0649 17.3035C18.1235 17.3973 18.205 17.4746 18.3017 17.5282C18.3985 17.5818 18.5073 17.61 18.6179 17.61H24.7778C25.2966 17.61 25.7943 17.4039 26.1611 17.037C26.528 16.6701 26.7341 16.1725 26.7341 15.6536Z",
    fill: "url(#paint2_linear_743_3682)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21387 7.02393H24.7773C25.1636 7.02393 25.5345 7.17756 25.8076 7.45068C26.0806 7.72372 26.2343 8.0939 26.2344 8.47998V15.6538C26.2343 16.0399 26.0806 16.41 25.8076 16.6831C25.5345 16.9562 25.1636 17.1099 24.7773 17.1099H18.6182C18.5924 17.1099 18.5665 17.1038 18.5439 17.0913C18.5215 17.0788 18.5029 17.0603 18.4893 17.0386L17.2988 15.1333L17.2021 14.9897C16.9679 14.664 16.6638 14.3937 16.3115 14.1987C15.9089 13.9759 15.4563 13.8589 14.9961 13.8589C14.5359 13.8589 14.0833 13.976 13.6807 14.1987C13.3284 14.3937 13.0242 14.6641 12.79 14.9897L12.6934 15.1333L11.5029 17.0386C11.4893 17.0603 11.4707 17.0788 11.4482 17.0913C11.4257 17.1038 11.3998 17.1099 11.374 17.1099H5.21387C4.82773 17.1098 4.45762 16.9562 4.18457 16.6831C3.91153 16.41 3.75786 16.04 3.75781 15.6538V8.47998C3.75789 8.09384 3.91152 7.72373 4.18457 7.45068C4.45762 7.17764 4.82773 7.02401 5.21387 7.02393Z",
    stroke: "url(#paint3_linear_743_3682)",
    strokeOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 11.0884H7.17067C6.99772 11.0884 6.83185 11.0197 6.70956 10.8974C6.58726 10.7751 6.51855 10.6093 6.51855 10.4363C6.51855 10.2633 6.58726 10.0975 6.70956 9.97518C6.83185 9.85288 6.99772 9.78418 7.17067 9.78418H22.8216C22.9945 9.78418 23.1604 9.85288 23.2827 9.97518C23.405 10.0975 23.4737 10.2633 23.4737 10.4363C23.4737 10.6093 23.405 10.7751 23.2827 10.8974C23.1604 11.0197 22.9945 11.0884 22.8216 11.0884Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3682",
    x: -8.74219,
    y: -5.47607,
    width: 47.4763,
    height: 35.0861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3682"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3682_clip_path",
    transform: "translate(8.74219 5.47607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7341 15.6536V8.48029C26.7341 7.96143 26.528 7.46382 26.1611 7.09693C25.7943 6.73004 25.2966 6.52393 24.7778 6.52393H5.21417C4.69531 6.52393 4.19771 6.73004 3.83082 7.09693C3.46393 7.46382 3.25781 7.96143 3.25781 8.48029V15.6536C3.25781 16.1725 3.46393 16.6701 3.83082 17.037C4.19771 17.4039 4.69531 17.61 5.21417 17.61H11.3741C11.4847 17.61 11.5935 17.5818 11.6902 17.5282C11.787 17.4746 11.8685 17.3973 11.9271 17.3035L13.1172 15.3986C13.3167 15.0804 13.5937 14.818 13.9223 14.6361C14.2509 14.4542 14.6204 14.3588 14.996 14.3588C15.3716 14.3588 15.741 14.4542 16.0696 14.6361C16.3983 14.818 16.6753 15.0804 16.8747 15.3986L18.0649 17.3035C18.1235 17.3973 18.205 17.4746 18.3017 17.5282C18.3985 17.5818 18.5073 17.61 18.6179 17.61H24.7778C25.2966 17.61 25.7943 17.4039 26.1611 17.037C26.528 16.6701 26.7341 16.1725 26.7341 15.6536Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3682",
    x: 6.51855,
    y: 9.78418,
    width: 16.9551,
    height: 3.3042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3682",
    x1: 1.30762,
    y1: 20.2183,
    x2: 24.1186,
    y2: 36.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3682",
    x1: 5.21387,
    y1: 0,
    x2: 28.694,
    y2: 4.96784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3682",
    x1: 3.25781,
    y1: 6.52393,
    x2: 26.0929,
    y2: 18.8026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3682",
    x1: 3.99145,
    y1: 7.02784,
    x2: 26.7341,
    y2: 7.02784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaSmallIcon01);
export default __webpack_public_path__ + "static/media/fea-small-icon01.f2ffc856a8e844f456bc877e8b803dc1.svg";
export { ForwardRef as ReactComponent };